import { EventType } from './event-type.interface';

export const PRESSURE: EventType = {
  name: 'Pressure',
  description: 'When a pressure sensor is triggered',
  route: 'pressure',
  category: 'Sensors',
  icon: 'pressure',
  whitelist: [
    {
      proxy: 'contactsingle_pressuresensor_c4',
      events: [1, 2]
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/pressure.type.ts